// extracted by mini-css-extract-plugin
export default {"container":"CalendarFooter_container__5sERU"};